/**
 * @fileoverview URL copy functionality
 */

/**
 * Copies the current URL to clipboard
 * @param {Event} evt - The click event
 */
function copyURI(evt) {
  evt.preventDefault();
  navigator.clipboard.writeText(window.location.href);
}

const copyLinks = document.querySelectorAll('.copy-btn');

for (const copyLink of copyLinks) {
  copyLink.addEventListener('click', copyURI);
}
